import { useContext, useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  IconButton
} from '@mui/material';
import CloseIcon from '@ant-design/icons/CloseOutlined';
import { NotificationContext } from '../../contexts/NotificationContext';

export default function PopupNotification() {
  const { notifications, markAsRead } = useContext(NotificationContext);
  const [currentPopup, setCurrentPopup] = useState(null);

  useEffect(() => {
    // Find first active, unread popup notification
    const unreadPopups = notifications.filter(
      n => n.type === 'popup' && n.status?.toLowerCase() === 'active' && !n.is_read
    );
    if (unreadPopups.length > 0) {
      setCurrentPopup(unreadPopups[0]);
    } else {
      setCurrentPopup(null);
    }
  }, [notifications]);

  const handleClose = async () => {
    if (currentPopup) {
      await markAsRead(currentPopup.id);
      setCurrentPopup(null);
    }
  };

  if (!currentPopup) return null;

  return (
    <Dialog
      open={!!currentPopup}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      aria-labelledby="popup-notification-title"
    >
      <DialogTitle id="popup-notification-title" sx={{ m: 0, p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h5">{currentPopup.title}</Typography>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <div dangerouslySetInnerHTML={{ __html: currentPopup.message }} />
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={handleClose} variant="contained" color="primary">
          Got it
        </Button>
      </DialogActions>
    </Dialog>
  );
}
